import { render, staticRenderFns } from "./SplitPaymentScreen.vue?vue&type=template&id=65e04b58&scoped=true"
import script from "./SplitPaymentScreen.vue?vue&type=script&lang=js"
export * from "./SplitPaymentScreen.vue?vue&type=script&lang=js"
import style0 from "./SplitPaymentScreen.vue?vue&type=style&index=0&id=65e04b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e04b58",
  null
  
)

export default component.exports